import styled from 'styled-components';
import { ListboxOptions } from '@headlessui/react';
import tw from 'twin.macro';

export const CustomListboxOptions = styled(ListboxOptions)`
  ${tw`absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none phone:text-sm`}
`;
